const routers = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    component: "AuthLayout",
    path: "/login",
    name: "Login",
    exact: false,
    childrens: [
      {
        component: "Login",
        path: "/",
        componentPath: "pages/Auth/Login",
        name: "Login",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "AuthLayout",
    path: "/forgot-password",
    name: "Login",
    exact: false,
    childrens: [
      {
        component: "ForgotPassword",
        path: "/",
        componentPath: "pages/Auth/ForgotPassword",
        name: "ForgotPassword",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "AuthLayout",
    path: "/reset-password",
    name: "Login",
    exact: false,
    childrens: [
      {
        component: "ResetPassword",
        path: "/",
        componentPath: "pages/Auth/ResetPassword",
        name: "ResetPassword",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/dashboard",
    name: "Dashboard",
    exact: false,
    childrens: [
      {
        component: "AdminDigiGold",
        path: "/:id",
        componentPath: "pages/Dashboard/AdminDigiGold/index.jsx",
        name: "AdminDigiGold",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/user-management",
    name: "UserManagement",
    exact: false,
    childrens: [
      {
        component: "UserManagement",
        path: "/",
        componentPath: "pages/UserManagement",
        name: "UserManagement",
        auth: false,
        exact: true,
      },
      {
        component: "AddRole",
        path: "/add-role",
        componentPath: "pages/UserManagement/AddRole",
        name: "AddRole",
        auth: false,
        exact: true,
      },
      {
        component: "AddRole",
        path: "/edit-role",
        componentPath: "pages/UserManagement/AddRole",
        name: "AddRole",
        auth: false,
        exact: true,
      },
      {
        component: "AddUser",
        path: "/add-user",
        componentPath: "pages/UserManagement/AddUser",
        name: "AddUser",
        auth: false,
        exact: true,
      },
      {
        component: "AddUser",
        path: "/edit-user",
        componentPath: "pages/UserManagement/AddUser",
        name: "AddUser",
        auth: false,
        exact: true,
      },
      {
        component: "ResetPasswords",
        path: "/reset-password",
        componentPath: "pages/UserManagement/ResetPassword",
        name: "ResetPasswords",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/export-users",
    name: "exportUserList",
    exact: false,
    childrens: [
      {
        component: "ExportUsers",
        path: "/",
        componentPath: "pages/ExportUsers",
        name: "ExportUsers",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/content-management",
    name: "ContentManagement",
    exact: false,
    childrens: [
      {
        component: "ContentManagement",
        path: "/:id",
        componentPath: "pages/ContentManagement",
        name: "ContentManagement",
        auth: false,
        exact: true,
      },
      {
        component: "OrderConfirmation",
        path: "/order-confirmation/:id",
        componentPath: "pages/ContentManagement/OrderConfirmation",
        name: "OrderConfirmation",
        auth: false,
        exact: true,
      },
      {
        component: "Banner",
        path: "/add-Banner/:id",
        componentPath: "pages/ContentManagement/Banner",
        name: "Banner",
        auth: false,
        exact: true,
      },
      {
        component: "Banner",
        path: "/edit-Banner/:id",
        componentPath: "pages/ContentManagement/Banner",
        name: "Banner",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/gold-maintenance",
    name: "GoldRateMaintenance",
    exact: false,
    childrens: [
      {
        component: "GoldRateMaintenance",
        path: "/",
        componentPath: "pages/GoldRateMaintenance",
        name: "GoldRateMaintenance",
        auth: false,
        exact: true,
      },
      {
        component: "GoldRate",
        path: "/view-gold",
        componentPath: "pages/GoldRateMaintenance/GoldRate",
        name: "GoldRate",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/order-management",
    name: "OrderManagement",
    exact: false,
    childrens: [
      {
        component: "AllOrders",
        path: "/",
        componentPath: "pages/OrderManagement/AllOrders/index.jsx",
        name: "AllOrders",
        auth: false,
        exact: true,
      },
      {
        component: "OrderDetails",
        path: "/order-detail",
        componentPath: "pages/OrderManagement/OrderDetails/index.jsx",
        name: "OrderDetails",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/scheme-management",
    name: "SchemeManagement",
    exact: false,
    childrens: [
      {
        component: "CreateScheme",
        path: "/create-scheme",
        componentPath: "pages/SchemeManagement/CreateScheme",
        name: "CreateScheme",
        auth: false,
        exact: true,
      },
      {
        component: "CreateScheme",
        path: "/create-scheme/:id",
        componentPath: "pages/SchemeManagement/CreateScheme",
        name: "CreateScheme",
        auth: false,
        exact: true,
      },
      {
        component: "ViewScheme",
        path: "/",
        componentPath: "pages/SchemeManagement/ViewScheme",
        name: "ViewScheme",
        auth: false,
        exact: true,
      },
      // {
      //   component: "CreateSubScheme",
      //   path: "/:section/:masterSchemeId/sub-scheme/:subSchemeName?/:subSchemeId?",
      //   componentPath: "pages/SchemeManagement/CreateSubScheme",
      //   name: "CreateSubScheme",
      //   auth: false,
      //   exact: true,
      // },
      {
        component: "CreateSubScheme",
        path: "/create-sub-scheme/:id/duplicate",
        componentPath: "pages/SchemeManagement/CreateSubScheme",
        name: "CreateSubScheme",
        auth: false,
        exact: true,
      },
      {
        component: "ViewMasterScheme",
        path: "/view-master/:id",
        componentPath: "pages/SchemeManagement/ViewMasterScheme",
        name: "ViewMasterScheme",
        auth: false,
        exact: true,
      },
      {
        component: "SubSchemeManagement",
        path: "/:section/view-sub-scheme-management/:subSchemeName/:subSchemeId",
        componentPath: "pages/SchemeManagement/SubSchemeManagement",
        name: "SubSchemeManagement",
        auth: false,
        exact: true,
      },
      {
        component: "EditContent",
        path: "/:modal/modal/:id",
        componentPath: "pages/SchemeManagement/EditModal",
        name: "EditModal",
        auth: false,
        exact: true,
      },

      {
        component: "CreateModal",
        path: "/:section/:masterSchemeId/sub-scheme/CreateModal", // For create
        componentPath: "pages/SchemeManagement/CreateModal",
        name: "CreateModal",
        auth: false,
        exact: true,
      },
      {
        component: "CreateModal",
        path: "/:section/:masterSchemeId/sub-scheme/:subSchemeName/:subSchemeId/CreateModal", // For edit
        componentPath: "pages/SchemeManagement/CreateModal",
        name: "CreateModal",
        auth: false,
        exact: true,
      },
      {
        component: "CreateSubScheme",
        path: "/:section/:masterSchemeId/sub-scheme", // For create
        componentPath: "pages/SchemeManagement/CreateSubScheme",
        name: "CreateSubScheme",
        auth: false,
        exact: true,
      },
      {
        component: "CreateSubScheme",
        path: "/:section/:masterSchemeId/sub-scheme/:subSchemeName/:subSchemeId", // For edit
        componentPath: "pages/SchemeManagement/CreateSubScheme",
        name: "CreateSubScheme",
        auth: false,
        exact: true,
      },
    ],

    // {
    //   component: "CreateModal",
    //   path: "/:section/:masterSchemeId/sub-scheme/:subSchemeName?/:subSchemeId?/CreateModal",
    //   componentPath: "pages/SchemeManagement/CreateModal",
    //   name: "CreateModal",
    //   auth: false,
    //   exact: true,
    // },
  },
  {
    component: "MainLayout",
    path: "/reportings",
    name: "Reportings",
    exact: false,
    childrens: [
      {
        component: "Reportings",
        path: "/",
        componentPath: "pages/Reportings",
        name: "Reportings",
        auth: false,
        exact: true,
      },
      {
        component: "Reportings",
        path: "/Trend-Analysis-Report",
        componentPath: "pages/Reportings",
        name: "Reportings",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/411-Registration-Trends",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/412-Conversion-Trends",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/413-Joining-Trends",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/414-Joining-Trends-(Amount)",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/415-Redemption-Trends",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/416-Redemption-Trends-(Amount)",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/417-Due-Collection-Trends",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/418-Due-Collection-Trends-Amount",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/419-Target-Collection-Trends-Weight",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/421-Total-Scheme-Balance",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      // {
      //   component: "TrendAnalysis",
      //   path: "/Trend-Analysis-Report/421-Total-Scheme-Balance",
      //   componentPath: "pages/Reportings/TrendAnalysis",
      //   name: "TrendAnalysis",
      //   auth: false,
      //   exact: true,
      // },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/423-Consolidated-Daily-Passbook",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/423-Consolidated-Daily-Amount",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/431-DigiGold-Receipt-Pattern",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/432-DigiGold-Balance-Pattern",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/433-DigiGold-Redemption-Pattern",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/441-SuperGold-Receipt-Pattern",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/442-SuperGold-Balance-Pattern",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/443-SuperGold-Redemption-Pattern",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/444-SuperGold-Installment-Pattern",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/445-SuperGold-Dues-Pattern",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysis",
        path: "/Trend-Analysis-Report/446-SuperGold-Delay-Pattern",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "RegistrationSummary",
        path: "/201-Registraton-Summary-Report",
        componentPath: "pages/Reportings/Report/MisReport/201",
        name: "RegistrationSummary",
        auth: false,
        exact: true,
      },
      {
        component: "SchemeCustomerSummary",
        path: "/202-Scheme-customer-summary-Report",
        componentPath: "pages/Reportings/Report/MisReport/202",
        name: "SchemeCustomerSummary",
        auth: false,
        exact: true,
      },
      {
        component: "ActiveCustomerSummary",
        path: "/203-Active-customer-summary-Report",
        componentPath: "pages/Reportings/Report/MisReport/203",
        name: "ActiveCustomerSummary",
        auth: false,
        exact: true,
      },
      {
        component: "ActivePassbookSummary",
        path: "/204-Active-passbook-summary-Report",
        componentPath: "pages/Reportings/Report/MisReport/204",
        name: "ActivePassbookSummary",
        auth: false,
        exact: true,
      },
      {
        component: "MaturedVsRedeemed",
        path: "/205-Matured-Vs-redeemed-Report",
        componentPath: "pages/Reportings/Report/MisReport/205",
        name: "MaturedVsRedeemed",
        auth: false,
        exact: true,
      },
      {
        component: "SGSCollectionSummary",
        path: "/206-SGS-collection-summary-Report",
        componentPath: "pages/Reportings/Report/MisReport/206",
        name: "SGSCollectionSummary",
        auth: false,
        exact: true,
      },
      {
        component: "DGPTargetCollectionReport",
        path: "/207-DGP-Target-collection-Report",
        componentPath: "pages/Reportings/Report/MisReport/207",
        name: "DGPTargetCollectionReport",
        auth: false,
        exact: true,
      },
      {
        component: "SGSCollectionPatternSummary",
        path: "/208-SGS-collection-pattern-summary-Report",
        componentPath: "pages/Reportings/Report/MisReport/208",
        name: "SGSCollectionPatternSummary",
        auth: false,
        exact: true,
      },
      {
        component: "SGSCollectionPattern",
        path: "/209-SGS-collection-pattern-Report",
        componentPath: "pages/Reportings/Report/MisReport/209",
        name: "SGSCollectionPattern",
        auth: false,
        exact: true,
      },
      {
        component: "PassbookBalanceReport",
        path: "/101-Passport-balance-Report",
        componentPath: "pages/Reportings/Report/SchemeReport/101",
        name: "PassbookBalanceReport",
        auth: false,
        exact: true,
      },
      {
        component: "PassbookDetailReport",
        path: "/108-Passbook-detail-Report",
        componentPath: "pages/Reportings/Report/SchemeReport/108",
        name: "PassbookDetailReport",
        auth: false,
        exact: true,
      },
      {
        component: "SchemeCollectionReport",
        path: "/102-Scheme-Collection-Report",
        componentPath: "pages/Reportings/Report/SchemeReport/102",
        name: "SchemeCollectionReport",
        auth: false,
        exact: true,
      },
      {
        component: "RedemptionReport",
        path: "/103-Redemption-Report",
        componentPath: "pages/Reportings/Report/SchemeReport/103",
        name: "RedemptionReport",
        auth: false,
        exact: true,
      },
      {
        component: "CustomerBalanceReport",
        path: "/104-Customer-Balance-Report",
        componentPath: "pages/Reportings/Report/SchemeReport/104",
        name: "CustomerBalanceReport",
        auth: false,
        exact: true,
      },
      {
        component: "CustomerSummaryReport",
        path: "/105-Customer-Summary",
        componentPath: "pages/Reportings/Report/SchemeReport/105",
        name: "CustomerSummaryReport",
        auth: false,
        exact: true,
      },
      {
        component: "PassbookStatementReport",
        path: "/106-Passbook-statement-report",
        componentPath: "pages/Reportings/Report/SchemeReport/106",
        name: "PassbookStatementReport",
        auth: false,
        exact: true,
      },
      {
        component: "CessionalReport",
        path: "/107-Cessional-passbook-Report",
        componentPath: "pages/Reportings/Report/SchemeReport/107",
        name: "CessionalReport",
        auth: false,
        exact: true,
      },
      {
        component: "MisReportPage",
        path: "/MIS-Report",
        componentPath: "pages/Reportings/MisReport",
        name: "MisReportPage",
        auth: false,
        exact: true,
      },
      {
        component: "SchemeReportPage",
        path: "/Scheme-Report",
        componentPath: "pages/Reportings/ReportScheme",
        name: "SchemeReportPage",
        auth: false,
        exact: true,
      },

      {
        component: "SummarySchemeAgeAnalysis",
        path: "/302-Scheme-Age-Analysis",
        componentPath:
          "pages/Reportings/SummaryDashboard/SummarySchemeAgeAnalysis.jsx",
        name: "SummarySchemeAgeAnalysis",
        auth: false,
        exact: true,
      },
      {
        component: "SummaryDailyReport",
        path: "/301-Daily-Summary-Report",
        componentPath:
          "pages/Reportings/SummaryDashboard/DailySummaryReport.jsx",
        name: "SummaryDailyReport",
        auth: false,
        exact: true,
      },

      {
        component: "MonthlySummaryReport",
        path: "/501-Summary-Balance-Report",
        componentPath: "pages/Reportings/MonthlySummary/Reports.jsx",
        name: "MonthlySummaryReport",
        auth: false,
        exact: true,
      },
      {
        component: "MonthlySummaryReport",
        path: "/502-Monthly-Summary-Collection",
        componentPath: "pages/Reportings/MonthlySummary/Reports.jsx",
        name: "MonthlySummaryReport",
        auth: false,
        exact: true,
      },
      {
        component: "MonthlySummaryReport",
        path: "/503-Daily-Summary-Collection",
        componentPath: "pages/Reportings/MonthlySummary/Reports.jsx",
        name: "MonthlySummaryReport",
        auth: false,
        exact: true,
      },
      {
        component: "MonthlySummaryReport",
        path: "/504-Scheme-Wise-Daily-Summary-Report",
        componentPath: "pages/Reportings/MonthlySummary/Reports.jsx",
        name: "MonthlySummaryReport",
        auth: false,
        exact: true,
      },

      {
        component: "RewardReportPage",
        path: "/reward-report",
        componentPath: "pages/Reportings/RewardReport",
        name: "RewardReportPage",
        auth: false,
        exact: true,
      },
      {
        component: "RewardReportTablePage",
        path: "/701-Rewards-Report",
        componentPath: "pages/Reportings/RewardReport/Reports.jsx",
        name: "RewardReportTablePage",
        auth: false,
        exact: true,
      },
      {
        component: "RewardReportTablePage",
        path: "/702-Rewards-Conversion",
        componentPath: "pages/Reportings/RewardReport/Reports.jsx",
        name: "RewardReportTablePage",
        auth: false,
        exact: true,
      },
      {
        component: "RewardReportTablePage",
        path: "/703-Reward-Value-Tracking",
        componentPath: "pages/Reportings/RewardReport/Reports.jsx",
        name: "RewardReportTablePage",
        auth: false,
        exact: true,
      },
      {
        component: "RewardReportTablePage",
        path: "/704-scheme-reward",
        componentPath: "pages/Reportings/RewardReport/Reports.jsx",
        name: "RewardReportTablePage",
        auth: false,
        exact: true,
      },

      {
        component: "FinancialYearReport",
        path: "/601-Conversion-Tracker",
        componentPath: "pages/Reportings/FinancialYear/Reports.jsx",
        name: "FinancialYearReport",
        auth: false,
        exact: true,
      },

      {
        component: "FinancialYearReport",
        path: "/602-Collection-Matrix",
        componentPath: "pages/Reportings/FinancialYear/Reports.jsx",
        name: "FinancialYearReport",
        auth: false,
        exact: true,
      },
      {
        component: "FinancialYearReport",
        path: "/603-Savings-Pattern-Trend",
        componentPath: "pages/Reportings/FinancialYear/Reports.jsx",
        name: "FinancialYearReport",
        auth: false,
        exact: true,
      },
      {
        component: "FinancialYearReport",
        path: "/604-Value-Trend",
        componentPath: "pages/Reportings/FinancialYear/Reports.jsx",
        name: "FinancialYearReport",
        auth: false,
        exact: true,
      },
      {
        component: "TrendAnalysisPage",
        path: "/trendanalysis",
        componentPath: "pages/Reportings/TrendAnalysis",
        name: "TrendAnalysisPage",
        auth: false,
        exact: true,
      },
      {
        component: "DownloadReports",
        path: "/Download Report",
        componentPath: "pages/Reportings/DownloadReport",
        name: "DownloadReports",
        auth: false,
        exact: true,
      },
      {
        component: "KycUpdationReports",
        path: "/Kyc-Updation-reports",
        componentPath: "pages/Reportings/KycUpdation",
        name: "KycUpdationReports",
        auth: false,
        exact: true,
      },
      {
        component: "KycUpdationTableReports",
        path: "/kycTable",
        componentPath: "pages/Reportings/KycUpdation/Reports.jsx",
        name: "KycUpdationTableReports",
        auth: false,
        exact: true,
      },
      {
        component: "AdharPanReport",
        path: "/adharPanVerifiedCustomer",
        componentPath:
          "pages/Reportings/Report/ReceiptReconciliationReport/803",
        name: "AdharPanReport",
        auth: false,
        exact: true,
      },
      {
        component: "EmailVerifiedCustomerReport",
        path: "/emailVerifiedCustomer",
        componentPath:
          "pages/Reportings/Report/ReceiptReconciliationReport/804",
        name: "EmailVerifiedCustomerReport",
        auth: false,
        exact: true,
      },
      {
        component: "ReviewSubmissionReport",
        path: "/reviewSubmissionReport",
        componentPath:
          "pages/Reportings/Report/ReceiptReconciliationReport/805",
        name: "ReviewSubmissionReport",
        auth: false,
        exact: true,
      },
      {
        component: "CustomerProfileReport",
        path: "/customerProfileReport",
        componentPath:
          "pages/Reportings/Report/ReceiptReconciliationReport/806",
        name: "CustomerProfileReport",
        auth: false,
        exact: true,
      },
      {
        component: "DataDelReport",
        path: "/dataDeletionReport",
        componentPath:
          "pages/Reportings/Report/ReceiptReconciliationReport/807",
        name: "DataDelReport",
        auth: false,
        exact: true,
      },
      {
        component: "ZerobounceEmailReport",
        path: "/zerobounceUsageReport",
        componentPath:
          "pages/Reportings/Report/ReceiptReconciliationReport/808",
        name: "ZerobounceEmailReport",
        auth: false,
        exact: true,
      },
      {
        component: "SurepasslogsReport",
        path: "/surepasslogs",
        componentPath:
          "pages/Reportings/Report/ReceiptReconciliationReport/809",
        name: "SurepasslogsReport",
        auth: false,
        exact: true,
      },
      {
        component: "MandateReport",
        path: "/1001-Mandate-Report",
        componentPath: "pages/Reportings/Report/ShedulePayment/1001",
        name: "MandatedReport",
        auth: false,
        exact: true,
      },
      {
        component: "MandatepresentedReport",
        path: "/1002-Mandate-PresentedReport",
        componentPath: "pages/Reportings/Report/ShedulePayment/1002",
        name: "MandatepresentedReport",
        auth: false,
        exact: true,
      },
      {
        component: "MandateReconciliationPage",
        path: "/1003-token-payments",
        componentPath: "pages/Reportings/Report/ShedulePayment/1003",
        name: "MandateReconciliationPage",
        auth: false,
        exact: true,
      },
      {
        component: "PassbookDueDateReport",
        path: "/1004-passbook-due-date-report",
        componentPath: "pages/Reportings/Report/ShedulePayment/1004",
        name: "PassbookDueDateReport",
        auth: false,
        exact: true,
      },
      {
        component: "CallBackRequestReport",
        path: "/callBackRequestReport",
        componentPath:
          "pages/Reportings/Report/ReceiptReconciliationReport/810/index.jsx",
        name: "CallBackRequestReport",
        auth: false,
        exact: true,
      },
      // {
      //   component: "CustomerProfileReport",
      //   path: "/customerProfileReport",
      //   componentPath:
      //     "pages/Reportings/Report/ReceiptReconciliationReport/806",
      //   name: "CustomerProfileReport",
      //   auth: false,
      {
        component: "ModalPrompt",
        path: "/1101-Modal-Promt",
        componentPath: "pages/Reportings/Report/ModalLogs/1101",
        name: "ModalPrompt",
        auth: false,
        exact: true,
      },


    ],
  },

  {
    component: "MainLayout",
    path: "/customer-management",
    name: "CustomerManagement",
    exact: false,
    childrens: [
      {
        component: "CustomerManagement",
        path: "/",
        componentPath: "pages/CustomerManagement",
        name: "CustomerManagement",
        auth: false,
        exact: true,
      },
      {
        component: "Scheme",
        path: "/:id/:userId",
        componentPath: "pages/CustomerManagement/CustomerDetail",
        name: "Scheme",
        auth: false,
        exact: true,
      },
      {
        component: "CustomerProfile",
        path: "/cust-profile/:id",
        componentPath: "pages/CustomerManagement/CustomerProfile",
        name: "CustomerProfile",
        auth: false,
        exact: true,
      },
    ],
  },

  {
    component: "MainLayout",
    path: "/settings",
    name: "Settings",
    exact: false,
    childrens: [
      {
        component: "Settings",
        path: "/",
        componentPath: "pages/Settings",
        name: "Settings",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/support-management",
    name: "SupportManagement",
    exact: false,
    childrens: [
      {
        component: "SupportManagement",
        path: "/",
        componentPath: "pages/SupportManagement",
        name: "SupportManagement",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/work-management",
    name: "WorkflowManagement",
    exact: false,
    childrens: [
      {
        component: "WorkflowManagement",
        path: "/:id",
        componentPath: "pages/WorkflowManagement",
        name: "WorkflowManagement",
        auth: false,
        exact: true,
      },
      {
        component: "Content",
        path: "/workflow-dashboard/content/:id",
        componentPath: "pages/WorkflowManagement/Content",
        name: "Content",
        auth: false,
        exact: true,
      },
      {
        component: "Order",
        path: "/workflow-dashboard/order/:id",
        componentPath: "pages/WorkflowManagement/Order",
        name: "Order",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/system-config",
    name: "SystemConfigSettings",
    exact: false,
    childrens: [
      {
        component: "SystemConfigSettings",
        path: "/",
        componentPath: "pages/SystemConfigSettings",
        name: "SystemConfigSettings",
        auth: false,
        exact: true,
      },
      {
        component: "Content",
        path: "/content/:id",
        componentPath: "pages/SystemConfigSettings/Content",
        name: "Content",
        auth: false,
        exact: true,
      }, {
        component: "AddModalPromts",
        path: "/modalpromts/:modaltype?/:id?",
        componentPath: "pages/SystemConfigSettings/addmodal",
        name: "AddModalPromts",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/referral-Management",
    name: "ReferralManagement",
    exact: false,
    childrens: [
      {
        component: "Users",
        path: "/alluser/:id",
        componentPath: "pages/ReferralManagement/Users",
        name: "Users",
        auth: false,
        exact: true,
      },
      {
        component: "ViewUsers",
        path: "/viewUser",
        componentPath: "pages/ReferralManagement/Users/AllUsers/ViewUsers",
        name: "ViewUsers",
        auth: false,
        exact: true,
      },
      {
        component: "ViewInbox",
        path: "/viewInbox",
        componentPath:
          "pages/ReferralManagement/Users/ApplicationInbox/ViewInbox",
        name: "ViewInbox",
        auth: false,
        exact: true,
      },
      {
        component: "ViewOutbox",
        path: "/viewOutbox",
        componentPath:
          "pages/ReferralManagement/Users/ApplicationInbox/ViewOutbox",
        name: "ViewOutbox",
        auth: false,
        exact: true,
      },
      {
        component: "Categories",
        path: "/categories",
        componentPath: "pages/ReferralManagement/Categories",
        name: "Categories",
        auth: false,
        exact: true,
      },
      {
        component: "AddCategories",
        path: "/categories/create-category",
        componentPath: "pages/ReferralManagement/Categories/AddCategory",
        name: "AddCategories",
        auth: false,
        exact: true,
      },
      {
        component: "EditCategories",
        path: "/categories/edit-category",
        componentPath: "pages/ReferralManagement/Categories/EditCategory",
        name: "EditCategories",
        auth: false,
        exact: true,
      },
      {
        component: "ViewCategories",
        path: "/categories/view-category/",
        componentPath: "pages/ReferralManagement/Categories/ViewCategory",
        name: "ViewCategories",
        auth: false,
        exact: true,
      },
      {
        component: "Campaigns",
        path: "/campaigns",
        componentPath: "pages/ReferralManagement/Campaigns",
        name: "Campaigns",
        auth: false,
        exact: true,
      },
      {
        component: "CreateCampaigns",
        path: "/campaigns/createCampaign",
        componentPath: "pages/ReferralManagement/Campaigns/CreateCampaign",
        name: "CreateCampaigns",
        auth: false,
        exact: true,
      },
      {
        component: "EditCampaigns",
        path: "/campaigns/editCampaigns/:id",
        componentPath: "pages/ReferralManagement/Campaigns/EditCampaign",
        name: "EditCampaigns",
        auth: false,
        exact: true,
      },
      {
        component: "ReferralFaqComponent",
        path: "/faq",
        componentPath: "pages/ReferralManagement/Faq",
        name: "ReferralFaqComponent",
        auth: false,
        exact: true,
      },
      {
        component: "AddFaq",
        path: "/faq/addfaq",
        componentPath: "pages/ReferralManagement/Faq/AddFaq",
        name: "AddFaq",
        auth: false,
        exact: true,
      },
      {
        component: "EditFaq",
        path: "/faq/editfaq",
        componentPath: "pages/ReferralManagement/Faq/EditFaq",
        name: "EditFaq",
        auth: false,
        exact: true,
      },
      {
        component: "ViewFaq",
        path: "/faq/viewfaq",
        componentPath: "pages/ReferralManagement/Faq/ViewFaq",
        name: "ViewFaq",
        auth: false,
        exact: true,
      },
      {
        component: "EmployeeManagement",
        path: "/EmployeeManagement",
        componentPath: "pages/ReferralManagement/EmployeeManagement",
        name: "EmployeeManagement",
        auth: false,
        exact: true,
      },
     {
        component: "ReferralReportRevampPage",
        path: "/referrelReports",
        componentPath: "pages/ReferralManagement/RevampReports/index.jsx",
        name: "ReferralReportRevampPage",
        auth: false,
        exact: true,
      },
      {
        component: "ReferrelReportPage",
        path: "/referrelReports/:id",
        componentPath: "pages/ReferralManagement/RevampReports/revampReports",
        name: "ReferrelReportPage",
        auth: false,
        exact: true,
      },
      {
        component: "CampaginSummaryReport",
        path: "/reports/campaign-summary-report",
        componentPath: "pages/ReferralManagement/Reports/CampaignSummaryReport",
        name: "CampaginSummaryReport",
        auth: false,
        exact: true,
      },
      {
        component: "ActiveRewardReport",
        path: "/reports/Active-Reward-Report",
        componentPath: "pages/ReferralManagement/Reports/ActiveRewardReport",
        name: "ActiveRewardReport",
        auth: false,
        exact: true,
      },
      {
        component: "ActiveConversionMediaReport",
        path: "/reports/Active-Conversion-Media-Report",
        componentPath:
          "pages/ReferralManagement/Reports/ActiveConversionMediaReport",
        name: "ActiveConversionMediaReport",
        auth: false,
        exact: true,
      },
      {
        component: "ActiveUserActivityTrackerReport",
        path: "/reports/Active-User-Activity-TrackerReport",
        componentPath:
          "pages/ReferralManagement/Reports/ActiveUserActivityTrackerReport",
        name: "ActiveUserActivityTrackerReport",
        auth: false,
        exact: true,
      },
      {
        component: "ActiveUserSummaryTracker",
        path: "/reports/Active-User-Summary-Tracker",
        componentPath:
          "pages/ReferralManagement/Reports/ActiveUserSummaryTracker",
        name: "ActiveUserSummaryTracker",
        auth: false,
        exact: true,
      },
      {
        component: "ApplicationProcessing",
        path: "/reports/Application-Processing",
        componentPath: "pages/ReferralManagement/Reports/ApplicationProcessing",
        name: "ApplicationProcessing",
        auth: false,
        exact: true,
      },
      {
        component: "ActiveConversionReport",
        path: "/reports/Active-Conversion-Report",
        componentPath:
          "pages/ReferralManagement/Reports/ActiveConversionReport",
        name: "ActiveConversionReport",
        auth: false,
        exact: true,
      },
      {
        component: "ActivePayoutReport",
        path: "/reports/Active-Payout-Report",
        componentPath: "pages/ReferralManagement/Reports/ActivePayoutReport",
        name: "ActivePayoutReport",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/deletion-Management",
    name: "DeletionRequest",
    exact: false,
    childrens: [
      {
        component: "DeletionRequestPage",
        path: "/deletion-request",
        componentPath: "pages/DeletionRequest",
        name: "DeletionRequestPage",
        auth: false,
        exact: true,
      },
      {
        component: "DeletionInboxPage",
        path: "/deletion-inbox",
        componentPath: "pages/DeletionRequest/DeletionInbox",
        name: "DeletionInboxPage",
        auth: false,
        exact: true,
      },
      {
        component: "ViewDeletionInboxPage",
        path: "/view-deletion-inbox",
        componentPath: "pages/DeletionRequest/ViewDeletionInbox",
        name: "ViewDeletionInboxPage",
        auth: false,
        exact: true,
      },
      {
        component: "DeletionOutboxPage",
        path: "/deletion-outbox",
        componentPath: "pages/DeletionRequest/DeletionOutbox",
        name: "DeletionOutboxPage",
        auth: false,
        exact: true,
      },
      {
        component: "ViewDeletionOutboxPage",
        path: "/view-deletion-outbox",
        componentPath: "pages/DeletionRequest/ViewDeletionOutbox",
        name: "ViewDeletionOutboxPage",
        auth: false,
        exact: true,
      },
      {
        component: "ViewDeletionOutboxPagePassbookDetailes",
        path: "/view-deletion-outbox/passbookDetailes",
        componentPath:
          "pages/DeletionRequest/ViewDeletionOutboxPagePassbookDetailes",
        name: "ViewDeletionOutboxPagePassbookDetailes",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/receipt-reconciliation",
    name: "ReceiptReconciliation ",
    exact: false,
    childrens: [
      {
        component: "ReceiptReconciliationPage",
        path: "/",
        componentPath: "pages/ReceiptReconciliation",
        name: "ReceiptReconciliationPage",
        auth: false,
        exact: true,
      },
    ],
  },
  // {
  //   component: "MainLayout",
  //   path: "/marketingManagement",
  //   name: "posReporting",
  //   exact: false,
  //   childrens: [
  //     {
  //       component: "PosReport",
  //       path: "marketingManagement/pos-reporting",
  //       componentPath: "pages/marketingManagement/PosReporting",
  //       name: "PosReport",
  //       auth: false,
  //       exact: true,
  //     },
  //      {
  //       component: "PosReport",
  //       path: "/fmReporting",
  //       componentPath: "pages/marketingManagement/PosReporting",
  //       name: "PosReport",
  //       auth: false,
  //       exact: true,
  //     },
  //   ],
  // },
  // {
  //   component: "MainLayout",
  //   path: "/DFM-Reporting",
  //   name: "fmReporting",
  //   exact: false,
  //   childrens: [
  //     {
  //       component: "PosReport",
  //       path: "/",
  //       componentPath: "pages/PosReporting",
  //       name: "PosReport",
  //       auth: false,
  //       exact: true,
  //     },
  //   ],
  // },
  {
    component: "MainLayout",
    path: "/crm-configuration",
    name: "CRMConfiguration",
    exact: false,
    childrens: [
      {
        component: "CRMConfiguration",
        path: "/",
        componentPath: "pages/CRMConfiguration",
        name: "CRMConfiguration",
        auth: false,
        exact: true,
      },
    ],
  },
  // {
  //   component: "MainLayout",
  //   path: "/mandate-reconciliation",
  //   name: "MandateReconciliation",
  //   exact: false,
  //   childrens: [
  //     {
  //       component: "MandateReconciliationPage",
  //       path: "/",
  //       componentPath: "pages/MandateReconciliation",
  //       name: "MandateReconciliationPage",
  //       auth: false,
  //       exact: true,
  //     },
  //   ],
  // },
  {
    component: "MainLayout",
    path: "/marketing-management",
    name: "MarketingManagement",
    exact: false,
    childrens: [
      {
        component: "MarketingManagementPage",
        path: "/",
        componentPath: "pages/marketingManagement",
        name: "MarketingManagementPage",
        auth: false,
        exact: true,
      },
      {
        component: "PosReport",
        path: "/posreporting",
        componentPath: "pages/marketingManagement/PosReporting",
        name: "PosReport",
        auth: false,
        exact: true,
      },
      {
        component: "PosReport",
        path: "/fmReporting",
        componentPath: "pages/marketingManagement/PosReporting",
        name: "PosReport",
        auth: false,
        exact: true,
      },
      {
        component: "SubikshamReportPage",
        path: "/subikshamreporting",
        componentPath: "pages/marketingManagement/subikshamReport",
        name: "SubikshamReportPage",
        auth: false,
        exact: true,
      },
      {
        component: "SponceReportpage",
        path: "/sponserreporting",
        componentPath: "pages/marketingManagement/sponcer",
        name: "SponceReportpage",
        auth: false,
        exact: true,
      },
      {
        component: "MarketingDownloadPage",
        path: "/marketingdownload",
        componentPath: "pages/marketingManagement/marketingdownload",
        name: "MarketingDownloadPage",
        auth: false,
        exact: true,
      },
    ],
  },
];
export default routers;
